import { render, staticRenderFns } from "./ExclusiveCnamePopover.vue?vue&type=template&id=db364390"
import script from "./ExclusiveCnamePopover.vue?vue&type=script&lang=js"
export * from "./ExclusiveCnamePopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports